import { useEffect } from 'react';

/** The legacy pages put their theme on <body> (qcw-body, qc-body, qc-auth-body, the login page's own). */
export function useBodyClass(className: string) {
  useEffect(() => {
    const previous = document.body.className;
    document.body.className = className;
    return () => {
      document.body.className = previous;
    };
  }, [className]);
}
